<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-ticket mr-2" />Draft Invoice</h5>
            <hr />
            <b-row>
                <b-col md="6">
                    Invoice untuk <strong>{{ data.return_to }}</strong><br />
                    Pengembalian dari <strong>{{ data.office }}</strong><br />
                    Divisi <strong>{{ data.division }}</strong><br />
                    {{ data.total_item }} barang
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="danger" @click="promptCancelInvoice">
                        <i class="fa fa-times mr-2" />Batalkan
                    </b-button>
                    <b-button variant="success" class="ml-2" @click="finalizeInvoice">
                        <i class="fa fa-check mr-2" />Finalisasi
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <b-input-group>
                        <b-input v-model="input.noFaktur" maxlength="100" style="max-width: 250px" placeholder="Input No. Faktur..." @keydown.enter="findItem" />
                        <b-input-group-append>
                            <b-button variant="dark" @click="findItem">Cari Barang</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :items="data.return_items"
                :fields="fields"
                responsive class="my-3"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Invoice masih kosong.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}<br />
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                        Grade <strong>{{ row.item.grade }} - {{ row.item.spec }}</strong>
                    </div>
                </template>
                <template v-slot:cell(warehouse)="row">
                    {{ row.item.warehouse }}
                </template>
                <template v-slot:cell(returnReason)="row">
                    {{ getReturnReasonString(row.item.return_reason) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="danger" v-b-tooltip.hover.top title="Hapus" @click="promptRemoveItem(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
        </b-card>
        <b-modal id="m-photo" title="Foto Barang" hide-footer>
            No. Faktur <strong>{{ activeItem.no_faktur_pgi }}</strong><br />
            {{ activeItem.type }} <span v-if="activeItem.year != null">({{ activeItem.year }})</span> - {{ activeItem.brand }} - {{ activeItem.kind }}
            <br /><br />
            <img :src="$BASE_FILE_PATH + '/' + activeItem.photo" width="100%" />
        </b-modal>
        <b-modal id="m-item-to-add" :title="invoiceDetailId == null ? 'Penambahan Barang' : 'Pengubahan Barang'" size="lg" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <ModalItemDraftingKirimBalik :noFaktur="noFakturPGI" :returnInvoiceId="Number($route.params.id)" @item-added="onItemAdded" />
        </b-modal>
        <b-modal id="m-finalize" title="Finalisasi Invoice" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="No. Ref Invoice" description="Wajib diisi. No. Ref akan ditampilkan di invoice. Maks. 20 karakter.">
                <b-input v-model="finalize.noRef" maxlength="20" />
            </b-form-group>
            <b-form-group label="Tanggal Pengembalian" description="Wajib diisi. Tanggal Penjualan yang akan dimunculkan di cetakan invoice sales.">
                <b-input v-model="finalize.returnAt" type="date" />
            </b-form-group>
            <b-form-group label="Catatan Invoice(Opsional)">
                <b-input v-model="finalize.note" maxlength="200" />
            </b-form-group>
            <div class="text-right mt-4">
                <b-button variant="primary" @click="moveToConfirmation">
                    Lanjutkan
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-finalize-confirm" title="Finalisasi Invoice" centered no-close-on-backdrop no-close-on-esc hide-footer :hide-header-close="isSubmitting">
            Konfirmasi akhir untuk pengukuhan invoice.
            <div class="mt-3">
                <div>
                    <strong>No. Ref</strong><br />
                    {{ finalData.noRef }}
                </div>
                <div class="mt-3">
                    <strong>Tanggal Pengembalian</strong><br />
                    {{ $helper.parseDate(finalData.returnAt) }}
                </div>
                <div class="mt-3">
                    <strong>Pengembalian Ke</strong><br />
                    {{ finalData.returnTo }}
                </div>
                <div class="mt-3">
                    <strong>Catatan</strong><br />
                    {{ finalize.note || "-" }}
                </div>
                <div class="mt-3">
                    <strong>Total Item</strong><br />
                    {{ finalData.totalItem }} item(s)
                </div>
                <div class="mt-4 text-right">
                    <b-button variant="primary" :disabled="isSubmitting" @click="execConfirmInvoice">
                        {{ isSubmitting ? "Memproses..." : "Transaksikan Invoice" }}
                    </b-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-pin" :title="pinTitle" centered hide-footer>
            <b-form-group label="Masukan PIN">
                <b-input type="password" v-model="pin" maxlength="10" @keydown.enter="checkPIN" autofocus />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="checkPIN">
                    Otorisasi
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-print" title="Cetak Invoice" centered hide-footer no-close-on-backdrop no-close-on-esc hide-header-close>
            Invoice berhasil dibuat. Tekan bagian "Sinar Mutiara Cell" untuk mencetak.
            <iframe :src="getInvoiceLink()" height="300px" width="100%" />
            Pastikan invoice sudah tercetak baik sebelum menekan tombol OK.
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="invoiceSizeCooldown" @click="toggleInvoiceSize">
                            Print {{ invoiceSize == 'A5' ? 'A4' : 'A5' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="finishInvoice">
                            OK
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ModalItemDraftingKirimBalik from './ModalItemDraftingKirimBalik.vue'

export default {
    components: {
       ModalItemDraftingKirimBalik
    },
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,

            noFakturPGI: "",
            invoiceDetailId: null,
            pin: "",
            pinTitle: "",
            afterPin: "",
            invoiceLink: "",
            invoiceLinkA4: "",

            data: {
                items: []
            },

            input: {
                noFaktur: ""
            },

            finalize: {
                note: "",
                noRef: "",
                returnAt: ""
            },

            finalData: {},

            fields: [
                { key: "barang", label: "Barang", sortable: true },
                { key: "noFakturImei", label: "No. Faktur & IMEI / SN", sortable: true },
                { key: "warehouse", label: "Gudang", sortable: true },
                { key: "returnReason", label: "Alasan Pengembalian", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            activeItem: {
                id: null,
                no_faktur_pgi: "",
                photo: ""
            },
            
            sortBy: null,
            sortDesc: false,

            invoiceSize: 'A5',
            invoiceSizeCooldown: false,

        }
    },

    watch: {

        "finalize.dp": function(newVal) {

            let cleaned = String(newVal).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.finalize.dp = res)

        }

    },

    methods: {

        init() {

            this.initStatus = 0

            let getData = this.getItems()

            Promise.all([getData]).then(() => {
                this.initStatus = 1
            })
            .catch(_ => this.initStatus = -1)

        },
        
        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            let param = ""
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "?sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }
            return this.$axios.get("inventory-return-pgi/draft/" + this.$route.params.id + param).then(res => {
                this.data = res.data.data
            })
            .catch(error => this.$helper.parseError(this, error))
        },

        findItem() {

            if(this.$helper.isBlank(this.input.noFaktur)) {
                return this.$helper.toastError(this, "Mohon mengisi nomor faktur!")
            }

            this.invoiceDetailId = null
            this.noFakturPGI = this.input.noFaktur
            this.$bvModal.show("m-item-to-add")

        },

        promptRemoveItem(item) {

            let confirmed = confirm(`Hapus ${item.type} (NF ${item.no_faktur_pgi}) dari invoice ini?`)
            if(!confirmed) return

            this.activeItem = item
            this.afterPin = "cancel-item"
            this.pinTitle = "Pembatalan Barang - NF " + item.no_faktur_pgi
            this.$bvModal.show("m-pin")

        },

        execRemoveItem() {

            let payload = {
                inventory_return_id: this.activeItem.id,
                return_invoice_id: this.$route.params.id,
                pin: this.pin
            }

            this.$axios.post("inventory-return-pgi/remove-item-return-invoice", payload).then(res => {
                this.$helper.toastSuccess(this, "Barang berhasil dihapus dari invoice!")
                this.pin = ""
                this.init()
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        onItemAdded(toastMessage) {

            this.$bvModal.hide("m-item-to-add")
            this.$helper.toastSuccess(this, toastMessage)
            this.input.noFaktur = ""
            this.noFakturPGI = ""
            this.invoiceDetailId = null
            this.init()

        },

        promptCancelInvoice() {

            let isConfirmed = confirm("Batalkan invoice ini? Invoice akan dihapus dan barang-barang akan dikembalikan ke status semula!")
            if(!isConfirmed) return

            this.afterPin = "cancel-invoice"
            this.pinTitle = "Pembatalan Invoice"
            this.$bvModal.show("m-pin")

        },

        execCancelInvoice() {

            let payload = {
                return_invoice_id: this.$route.params.id,
                pin: this.pin
            }

            this.$axios.post("inventory-return-pgi/cancel-return-invoice", payload).then(_ => {
                this.$router.push({ path: "/kirim-balik/invoice" })
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        finalizeInvoice() {

            if(this.data.return_items.length == 0) {
                return this.$helper.toastError(this, "Invoice masih kosong / tidak ada barang!")
            }

            this.$bvModal.show("m-finalize")

        },

        // moveToPaymentMethod() {

        //     if(this.$helper.isBlank(this.finalize.discount)) {
        //         return this.$helper.toastError(this, "Mohon mengisi diskon!")
        //     }

        //     let payload = this.getFinalizePayload(2)
        //     if(typeof payload === "string") return this.$helper.toastError(this, payload)

        //     this.isSubmitting = true
        //     this.$axios.post("invoice/finalize", payload).then(res => {


        //         this.$bvModal.show("m-finalize-discount")

        //     })
        //     .catch(error => this.$helper.parseError(this, error))
        //     .finally(() => this.isSubmitting = false)

        // },

        moveToConfirmation() {

            if(this.$helper.isBlank(this.finalize.noRef)) {
                return this.$helper.toastError(this, "Mohon mengisi No. Ref Invoice!")
            }

            if(this.$helper.isBlank(this.finalize.returnAt)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengembalian!")
            }

            this.finalData = {
                noRef: this.finalize.noRef,
                returnAt: this.finalize.returnAt,
                returnTo: this.data.return_to,
                note: this.finalize.note,
                totalItem: this.data.total_item
            }

            this.$bvModal.show("m-finalize-confirm")

        },

        execConfirmInvoice() {

            let isConfirmed = confirm("Transaksikan invoice ini? Invoice yang sudah ditransaksikan tidak dapat dibatalkan!")
            if(!isConfirmed) return

            let payload = {
                return_invoice_id: this.$route.params.id,
                note: this.finalize.note,
                noRef: this.finalData.noRef,
                returnAt: this.finalData.returnAt
            }

            this.isSubmitting = true
            this.$axios.post("inventory-return-pgi/finalize-return-invoice", payload).then(res => {

                this.$bvModal.hide("m-finalize-confirm")
                this.invoiceLink = `${this.$BASE_PRINT_FILE_PATH}/${res.data.data.link}`
                this.invoiceLinkA4 = `${this.$BASE_PRINT_FILE_PATH}/${res.data.data.linka4}`
                this.$bvModal.show("m-print")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        finishInvoice() {
            this.$router.push({ path: "/kirim-balik/invoice" })
        },

        checkPIN() {

            if(this.pin == "") return this.$helper.toastError(this, "PIN kosong!")

            let payload = {
                pin: this.pin
            }

            this.isSubmitting = true
            this.$axios.post("invoice/check-pin", payload).then(_ => {

                this.$bvModal.hide("m-pin")

                switch(this.afterPin) {
                    case "cancel-invoice":
                        this.execCancelInvoice()
                        break

                    case "cancel-item":
                        this.execRemoveItem()
                        break

                    default: break

                }

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        getReturnReasonString(returnReason) {
            switch(returnReason) {
                case 0: return "Tidak Ada"
                case 1: return "Inventaris"
                case 2: return "Pergantian Barang"
                case 3: return "Prive Pak Andrew"
                case 4: return "Barang Tebusan"
                case 5: return "ICloud/Account"
            }
        },

        getInvoiceLink() {
            if(this.invoiceSize == 'A5'){
                return this.invoiceLink
            }
            else{
                return this.invoiceLinkA4
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true
            if(this.invoiceSize == 'A5') this.invoiceSize = 'A4'
            else this.invoiceSize = 'A5'
            setTimeout(function(){
                this.invoiceSizeCooldown = false
            }.bind(this),2000);
        },

    },
    created() {

        this.init()

        let tzoffset = (new Date()).getTimezoneOffset() * 60000
        let localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1)
        this.finalize.returnAt = localISOTime.substring(0, 10)

    }
}
</script>

<style>

</style>
